<template>
    <div class="ui warning message">
      <i class="close icon"></i>
      <div class="header">
        Keine {{name}} gefunden.
      </div>
      Bitte einen Eintrag anlegen.
    </div>
</template>

<script>
    export default {
        name: 'NoDataFound',
        props: {
            name: name
        }
    }
</script>